
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useState } from "react";
import { X } from "lucide-react";

const CTASection = () => {
  const { user } = useAuth();
  const [isDismissed, setIsDismissed] = useState(false);

  // Don't render for logged-in users or if dismissed
  if (user || isDismissed) {
    return null;
  }

  return (
    <section className="py-16 bg-anyskill-purple text-white relative">
      <Button
        variant="ghost"
        size="sm"
        className="absolute top-4 right-4 text-white hover:bg-white/20"
        onClick={() => setIsDismissed(true)}
        aria-label="Dismiss banner"
      >
        <X className="h-4 w-4" />
      </Button>
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-6">Ready to Get Started?</h2>
        <p className="text-lg mb-8 max-w-2xl mx-auto">
          Join our community today and start offering your skills or find the help you need.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button className="bg-anyskill-purple hover:bg-anyskill-purple/90 text-white px-6 py-6 font-inter font-medium text-lg border border-white" asChild>
            <Link to="/offer-service">Offer a Service</Link>
          </Button>
          <Button variant="outline" className="border-anyskill-blue text-anyskill-blue hover:bg-anyskill-blue hover:text-white px-6 py-6 font-inter font-medium text-lg" asChild>
            <Link to="/discover-services">Discover Services</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
